module.exports = __webpack_public_path__ + "static/media/Stand-Up-Sprint-1-Audio-3.b97d7937.mp3";